'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/zhujian/Desktop/code/live_system/live/~/querystring/index.js
// module id = 85
// module chunks = 0